export interface EntitySummaryPayloadModel {
  from: string;
  to: string;
  entityId: string;
  siteId?: string;
  isMock?: boolean;
}

export interface EntitySummaryResponseModel {
  timeTakenInMin: number;
  distanceTravelled: number;
}

export interface EntitySummaryModel {
  timeTaken: number;
  distance: number;
}
